import axios from "axios";

export const sendListingViewAction = async ({ memberId, userIdentifier, actionName, baseUrl, queryParams = "" }) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/action-tracker/v1/trigger-batch`;

  return axios.post(url, {
    member_id: memberId,
    user_identifier: userIdentifier,
    action_name: actionName,
    base_url: baseUrl?.toString(),
    query_params: queryParams,
  });
};
